import { IconEyeOff } from './QuirkIcons/index.js';
import styles from './PrivateConversationBanner.module.css';
import { pluralize } from '../util/pluralize.js';

export interface PrivateConversationBannerProps {
	plural?: boolean;
	seller?: boolean;
}

export function PrivateConversationBanner({ plural, seller }: PrivateConversationBannerProps) {
	return (
		<div className={styles.PrivateConversationBanner}>
			<IconEyeOff size="small" />
			<span>
				{pluralize(plural ? 2 : 1, 'Private Conversation')}
				{seller ? '' : ' With Seller'}
			</span>
		</div>
	);
}
